angular
	.module 'App.Repository'
	.factory 'IntegrationFileRepository', ['RenderRepository', 'BaseRepository', (RenderRepository, BaseRepository) ->
		class IntegrationFileRepository extends BaseRepository
			@resource = '/integration_files'
			@isRestricted = true

			download: (fileId) ->
				return RenderRepository.downloadFromUrl @toString(null, "/#{fileId}/download")

		return new IntegrationFileRepository
	]
